<template>
  <modal id="editEmailTemplate"
         :show="showModal"
         modal-classes="modal-dialog-centered modal-lg"
         showClose
         @close="close"
  >
    <template slot="header">
      <h4 class="modal-title">
        {{ $t('emailTemplates.edit.titleText') }}
      </h4>
    </template>
    <template>
      <div class="text-center text-muted mb-2">
        <small>{{ $t('emailTemplates.edit.helpText') }}</small>
      </div>

      <base-alert v-if="alert" dismissible :dismiss-callback="() => alert=false" type="danger">
        <!-- TODO: add error translation -->
        {{ getActionErrorDetails }}
      </base-alert>

      <form role="form" @submit.prevent="validate()">
        <div class="row">
          <label class="col-sm-3 col-form-label">{{ $t('emailTemplates.form.type') }}</label>
          <div class="col-md-9">
            <base-input disabled v-model="formDetails.type">
            </base-input>
          </div>
        </div>
        <div class="row">
          <label class="col-sm-3 col-form-label">{{ $t('emailTemplates.form.language') }}</label>
          <div class="col-md-9">
            <base-input disabled v-model="formDetails.language">
            </base-input>
          </div>
        </div>
        <div class="row">
          <label class="col-sm-3 col-form-label">{{ $t('emailTemplates.form.short_name') }}</label>
          <div class="col-md-9">
            <base-input
              data-vv-as="'short_name'"
              name="short_name"
              v-validate="modelValidations.required"
              :error="getError('short_name')"
              v-model="formDetails.short_name">
            </base-input>
          </div>
        </div>
        <div class="row">
          <label class="col-sm-3 col-form-label">{{ $t('emailTemplates.form.email_subject') }}</label>
          <div class="col-md-9">
            <base-input
              data-vv-as="'email_subject'"
              name="email_subject"
              v-validate="modelValidations.required"
              :error="getError('email_subject')"
              v-model="formDetails.email_subject">
            </base-input>
          </div>
        </div>
        <div class="row">
          <label class="col-sm-3 col-form-label">{{ $t('emailTemplates.form.description') }}</label>
          <div class="col-md-9">
            <base-input
              data-vv-as="'description'"
              name="description"
              v-validate="modelValidations.required"
              :error="getError('description')"
              v-model="formDetails.description">
            </base-input>
          </div>
        </div>

        <div class="row">
          <label class="col-sm-3 col-form-label">{{ $t('emailTemplates.form.email_content_html') }}</label>
          <div class="col-md-9">
            <base-input :error="getError('email_content_html')">
                <textarea class="form-control"
                          name="email_content_html"
                          data-vv-as="'email_content_html'"
                          v-validate="modelValidations.required"
                          v-model="formDetails.email_content_html"
                          rows="2"/>
            </base-input>
          </div>
        </div>
        <div class="row">
          <label class="col-sm-3 col-form-label">{{ $t('emailTemplates.form.email_content') }}</label>
          <div class="col-md-9">
            <base-input :error="getError('email_content')">
                <textarea class="form-control"
                          name="email_content"
                          data-vv-as="'email_content'"
                          v-validate="modelValidations.required"
                          v-model="formDetails.email_content"
                          rows="2"/>
            </base-input>
          </div>
        </div>
        <div class="text-center">
          <base-button
            type="info"
            :loading="updating"
            class="my-4"
            native-type="submit"
          >{{ $t('emailTemplates.edit.actionBtnLabel') }}
          </base-button>
        </div>
      </form>
    </template>
  </modal>
</template>


<script>
  import {BaseAlert, Modal} from 'src/components';
  import {Option, Select} from 'element-ui';
  import {mapActions, mapState} from "vuex";

  export default {
    name: 'edit-fare-group',
    components: {
      [Option.name]: Option,
      [Select.name]: Select,
      Modal,
      BaseAlert
    },
    props: {
      formDetails: {
        type: Object,
        required: true
      },
      show: {
        type: Boolean,
        required: true
      },
    },
    data() {
      return {
        alert: false,
        modelValidations: {
          required: {
            required: true
          }
        }
      }
    },
    computed: {
      ...mapState({
        updating: state => state.email_templates.updating,
        error: state => state.email_templates.error,
      }),
      getActionErrorDetails() {
        return this.error ? this.error.bodyText : null;
      },
      showModal() {
        return this.show == true
      }
    },
    watch: {
      "$store.state.fare_groups.error"(error) {
        this.error = error
      }
    },
    methods: {
      ...mapActions(['UpdateEmailTemplate']),
      close: function () {
        this.$emit('close');
      },
      getError(fieldName) {
        return this.errors.first(fieldName);
      },
      validate() {
        this.$validator.validateAll().then(isValid => {
          if (isValid) {
            this.update()
          }
        });
      },
      update: function () {
        this.UpdateEmailTemplate(this.formDetails).then(() => {
          if (this.error != null) {
            this.alert = true
          } else {
            this.$notify({
              type: 'success',
              message: this.$t('emailTemplates.edit.updatedNotification', this.formDetails),
              icon: 'tim-icons icon-alert-circle-exc'
            })
            this.close()
          }
        });
      }
    }
  }
</script>
